module.exports = __webpack_public_path__ + "img/2_2.616670d0.png";